import { LeftOutlined } from '@ant-design/icons'
import { Button, Card, Flex, Tabs } from 'antd'
import { TabsProps } from 'antd/lib'
import { useNavigate, useParams } from 'react-router-dom'

import { Permissions } from 'src/api/requests'
import { LoadingScreen, PageBreadcrumbs } from 'src/components'
import { useUser } from 'src/hooks'
import { useLocales } from 'src/locales'

import {
  PersonNewBornTable,
  PersonPregnancyBirths,
  PersonPregnancyDetails
} from '../../components'
import { usePersonBreadcrumb } from '../../hooks'
import { PersonInvestigationsPage } from '../PersonInvestigationsPage'

export const PersonPregnancyTabsPage = () => {
  const { t } = useLocales()
  const { personId } = useParams()
  const { hasPermission } = useUser()
  const navigate = useNavigate()

  const { breadcrumbItems, fullName, isLoadingPerson } =
    usePersonBreadcrumb(personId)

  const tabItems: TabsProps['items'] = [
    {
      key: 'table',
      label: t('persons.person_pregnancy_details'),
      children: <PersonPregnancyDetails />
    },
    {
      key: 'investigations',
      label: t('persons.person_investigations'),
      children: <PersonInvestigationsPage showPregnantOnly />
    },
    ...(hasPermission(
      Permissions.TREATMENT_PREGNANCY_MONITORING_BIRTH_VIEW_BIRTH_S
    )
      ? [
          {
            key: 'births',
            label: t('pregnancy.births'),
            children: <PersonPregnancyBirths />
          }
        ]
      : []),
    ...(hasPermission(
      Permissions.TREATMENT_PREGNANCY_MONITORING_NEWBORN_VIEW_NEWBORN_S
    )
      ? [
          {
            key: 'newborns',
            label: t('pregnancy.newBorns'),
            children: <PersonNewBornTable />
          }
        ]
      : [])
  ]

  const onBackClick = () => {
    navigate('..', { relative: 'path' })
  }

  if (isLoadingPerson) {
    return <LoadingScreen />
  }

  return (
    <PageBreadcrumbs title={fullName} items={breadcrumbItems}>
      <Flex vertical gap={24}>
        <Flex justify="space-between">
          <Button
            icon={<LeftOutlined />}
            className="fit-content"
            onClick={onBackClick}
          >
            {t('common.back')}
          </Button>
        </Flex>

        <Card>
          <Tabs type="card" items={tabItems} />
        </Card>
      </Flex>
    </PageBreadcrumbs>
  )
}
